<template>
    <v-footer color="white" class="footerpart" inset>
      <v-col cols="12">
            <v-row justify="center" no-gutters>
        <!-- <v-divider /> -->

        </v-row>
        <div  class="grey--text text--darken-2 text-center font-weight-bold">Prosecutor General's Office — © {{ new Date().getFullYear() }}</div>
      </v-col>
    </v-footer>
</template>
<script>
export default {
    name: "Footer",
    data: () => ({

    }),
}
</script>
<style lang="scss">
  .v-application .footerpart{
    border-top:1px solid rgba(0,0,0,0.1)!important;
  }
</style>